import { render, staticRenderFns } from "./Prints.vue?vue&type=template&id=0b89c38a&scoped=true&"
import script from "./Prints.vue?vue&type=script&lang=js&"
export * from "./Prints.vue?vue&type=script&lang=js&"
import style0 from "./Prints.vue?vue&type=style&index=0&id=0b89c38a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b89c38a",
  null
  
)

export default component.exports